/* =========================================================
   PCA — DESIGN F "NEON POP × CANVA構成"
   A案（ネオンポップ）ベースにクライアントのCanva構成を反映。
   CONTENT（shared） + CONTENT_F（F専用差分）からDOMを生成。
   データは創作しない。
   ========================================================= */
(function () {
  "use strict";

  /* ---------- data (共有CONTENTにF差分をマージ) ---------- */
  const C = Object.assign(
    {},
    typeof CONTENT !== "undefined" ? CONTENT : {},
    typeof CONTENT_F !== "undefined" ? CONTENT_F : {}
  );

  /* ---------- helpers ---------- */
  const $app = document.getElementById("app");

  // 管理番号サフィックス（#260066 等）とゴミ末尾スペースを除去
  function cleanTitle(t) {
    return String(t == null ? "" : t)
      .replace(/[#＃]\s*\d+\s*$/u, "")
      .replace(/\s+$/u, "")
      .trim();
  }

  // 価格を ¥3,480 形式へ（string / number 両対応）
  function yen(v) {
    const n = Number(String(v).replace(/[^\d.]/g, ""));
    if (!isFinite(n)) return "";
    return "¥" + n.toLocaleString("ja-JP");
  }

  /* ---------- 画像配信の最適化（2026-08-13 TOP高速化） ----------
     Shopify CDN（cdn.shopify.com / *.myshopify系の /cdn/shop/）は URLに ?width= を
     付けるとその幅にリサイズして返す。従来は 1000〜2000px の原寸が返っており、
     92〜278px でしか表示していない画像まで原寸を落としていた（TOPの画像 約4MB）。
     表示幅の1x/2xだけをsrcsetで配信し、端末の解像度に合ったものを選ばせる。 */
  function cdnUrl(url, w) {
    if (!url || typeof url !== "string") return url;
    if (!/(cdn\.shopify\.com|\/cdn\/shop\/)/.test(url)) return url;
    const parts = url.split("?");
    const q = (parts[1] || "").split("&").filter(function (p) {
      return p && !/^(width|height|crop)=/.test(p);
    });
    q.push("width=" + w);
    return parts[0] + "?" + q.join("&");
  }

  // 表示幅 w（CSSピクセル）に合わせた src/srcset を作る。extra で alt 等を足す。
  function imgAttrs(url, w, extra) {
    const a = Object.assign({ loading: "lazy", decoding: "async" }, extra || {});
    const x1 = cdnUrl(url, w);
    const x2 = cdnUrl(url, w * 2);
    a.src = x1;
    if (x1 !== x2) a.srcset = x1 + " 1x, " + x2 + " 2x";
    return a;
  }

  // URLの pathname だけを取り出して比較する（2026-09-24追加）。
  // クエリ文字列（?variant=123等）や末尾スラッシュ・大文字小文字の違いを吸収し、
  // "/products/xxxx?variant=123" と "/products/xxxx" を同一商品として扱う。
  function productPath(url) {
    try {
      return new URL(String(url || ""), window.location.origin).pathname
        .replace(/\/+$/, "")
        .toLowerCase();
    } catch (e) {
      return String(url || "").split(/[?#]/)[0].replace(/\/+$/, "").toLowerCase();
    }
  }

  // レビューの商品画像検索（2026-09-23・クライアント指示。2026-09-24にpathname一致へ強化）。
  // REVIEWS データ自体には画像フィールドが無いため、同じ商品（pathname一致）を持つ
  // 既存の商品データ（ランキング/新着＝実在確認済みの画像URL）から突き合わせて取得する。
  // 新しい画像を推測で設定することはしない：見つからない場合はそのカードに画像を出さない。
  function findReviewImage(url) {
    const target = productPath(url);
    if (!target) return null;
    const sources = [C.RANKING_BAKED, C.NEW_ARRIVALS_BAKED, C.RANKING];
    for (let i = 0; i < sources.length; i++) {
      const list = sources[i];
      if (!list || !list.length) continue;
      const hit = list.find(function (p) { return p && p.image && productPath(p.url) === target; });
      if (hit) return hit;
    }
    return null;
  }

  /* ---------- #PCAのある暮らし ギャラリー画像の日替わりローテーション（2026-09-24追加） ----------
     - 画像プールは新規に用意せず、実在する商品データ PRODUCTS（f-data.js）の image を使う。
       ただしPRODUCTS全件（商品カタログ写真も含む60件）をそのまま使うのではなく、
       CONTENT_F.PCA_LIFE_GALLERY_HANDLES（f-content_f.js・手動キュレーション）に
       列挙された handle と一致するものだけをプール化する。目視確認済みの
       「実際にケースを持っている／手元・コーデ・日常の中で使っている／複数ケースを
       並べたSNS向き／PCAの世界観が伝わるライフスタイル写真」だけに絞るためで、
       白背景の商品単体画像・販促テキスト入り画像等は含めない（画像URLの捏造・推測はしない）。
       将来ライフスタイル画像を追加したい場合は、f-content_f.js側にhandleを1行足すだけでよい。
     - キュレーションリストが空/取得不可の場合のみ、従来の固定6枚（PRODUCTS[8..13]）にフォールバックする。
     - Math.random() は使わない。日付（Asia/Tokyo基準・YYYY-MM-DD）から決定的なseedを作り、
       そのseedによるFisher-Yatesでプールを並べ替えて先頭n件を採る。
       同じ日は全ユーザーが同じ並び・何度リロードしても同じ並びになり、
       日本時間0時をまたぐと自動的に組み合わせが変わる。 */
  const PCA_LIFE_IMAGE_POOL = (function () {
    const handles = C.PCA_LIFE_GALLERY_HANDLES || [];
    const list = typeof PRODUCTS !== "undefined" ? PRODUCTS : [];
    if (!handles.length) return [];
    const byHandle = {};
    list.forEach(function (p) { if (p && p.image) byHandle[p.handle] = p; });
    return handles.map(function (h) { return byHandle[h]; }).filter(Boolean);
  })();

  // 今日の日付をJST基準のYYYY-MM-DDで取得（サーバー/端末のタイムゾーンに依存しない）。
  function jstDateKey() {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: "Asia/Tokyo",
      year: "numeric", month: "2-digit", day: "2-digit",
    }).format(new Date());
  }
  // 文字列→32bit整数の簡易ハッシュ（暗号強度は不要。日替わりseedの再現性のみが目的）。
  function seedFromString(s) {
    let h = 2166136261;
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }
  // シード付き擬似乱数生成器（mulberry32）。同じseedなら常に同じ数列を返す＝Math.random()の代替。
  function mulberry32(seed) {
    return function () {
      seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
      let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  // pool から n 件を「その日だけ安定した」順序で選ぶ。
  function dailyPick(pool, n) {
    const rand = mulberry32(seedFromString(jstDateKey()));
    const arr = pool.slice();
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(rand() * (i + 1));
      const tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr.slice(0, n);
  }

  // 属性を安全にセットしてノード生成
  function el(tag, opts) {
    const node = document.createElement(tag);
    if (!opts) return node;
    if (opts.class) node.className = opts.class;
    if (opts.text != null) node.textContent = opts.text;
    if (opts.html != null) node.innerHTML = opts.html;
    if (opts.attrs) {
      for (const k in opts.attrs) {
        if (opts.attrs[k] != null) node.setAttribute(k, opts.attrs[k]);
      }
    }
    if (opts.children) {
      opts.children.forEach(function (c) {
        if (c) node.appendChild(c);
      });
    }
    return node;
  }

  // "\n" を <br> に変換したテキストを持つ要素を作る（innerHTML不使用・エスケープ不要）。
  // 2026-09-23: 複数購入割引バナー／お急ぎ発送バナーの2〜3行文言表示のために追加。
  function multilineText(tag, cls, text) {
    const node = el(tag, { class: cls });
    String(text || "").split("\n").forEach(function (line, i) {
      if (i > 0) node.appendChild(document.createElement("br"));
      node.appendChild(document.createTextNode(line));
    });
    return node;
  }

  // ★を stars 個生成
  function starsHTML(n) {
    const full = Math.max(0, Math.min(5, Number(n) || 0));
    return (
      '<span class="stars" aria-label="星' +
      full +
      'つ">' +
      "★".repeat(full) +
      "☆".repeat(5 - full) +
      "</span>"
    );
  }

  // section ラッパ
  function section(id, opts) {
    opts = opts || {};
    const sec = el("section", {
      class: "sec " + (opts.class || ""),
      attrs: { id: id },
    });
    const inner = el("div", { class: "wrap" });
    sec.appendChild(inner);
    sec._inner = inner;
    return sec;
  }

  function heading(text, opts) {
    opts = opts || {};
    return el("h2", {
      class: "sec-title " + (opts.class || ""),
      text: text,
    });
  }

  const frag = document.createDocumentFragment();

  /* ---- SVGアイコン（インライン・外部読込なし） ---- */
  const ICON = {
    Instagram:
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1.1" fill="currentColor" stroke="none"/></svg>',
    YouTube:
      '<svg viewBox="0 0 24 24" width="21" height="21" fill="currentColor"><path d="M23 12s0-3.2-.4-4.7a2.5 2.5 0 0 0-1.8-1.8C19.2 5 12 5 12 5s-7.2 0-8.8.5A2.5 2.5 0 0 0 1.4 7.3C1 8.8 1 12 1 12s0 3.2.4 4.7a2.5 2.5 0 0 0 1.8 1.8C4.8 19 12 19 12 19s7.2 0 8.8-.5a2.5 2.5 0 0 0 1.8-1.8C23 15.2 23 12 23 12zM9.8 15.3V8.7l6 3.3-6 3.3z"/></svg>',
    TikTok:
      '<svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor"><path d="M16.5 3c.3 2.1 1.6 3.8 3.7 4.1v2.6c-1.3.1-2.5-.3-3.7-1v5.9c0 3.6-2.7 5.9-5.8 5.4-3-.5-4.6-3.9-3.3-6.7.9-1.9 3-2.9 5-2.5v2.8c-.4-.1-.9-.2-1.3-.1-1.1.2-1.8 1.2-1.6 2.3.2 1.1 1.3 1.8 2.4 1.5.9-.2 1.5-1 1.5-2V3h3.1z"/></svg>',
    Pinterest:
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12 2C6.5 2 3 5.6 3 9.9c0 2.6 1.4 4.8 3.4 5.6.3.1.5 0 .6-.3l.2-1c.1-.3 0-.4-.2-.7-.5-.6-.8-1.4-.8-2.5 0-2.9 2.2-5.5 5.7-5.5 3.1 0 4.8 1.9 4.8 4.4 0 3.3-1.5 6.1-3.6 6.1-1.2 0-2.1-1-1.8-2.2.3-1.5 1-3.1 1-4.1 0-.9-.5-1.7-1.6-1.7-1.3 0-2.3 1.3-2.3 3 0 1.1.4 1.8.4 1.8l-1.4 6c-.3 1.3-.1 3-.1 3.2 0 .1.2.2.3.1.1-.1 1.6-2 2.1-3.9l.8-3c.4.8 1.6 1.4 2.8 1.4 3.7 0 6.3-3.4 6.3-7.9C21 5.1 17.9 2 12 2z"/></svg>',
    search:
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>',
    account:
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 20.5C4 16.9 7.6 15 12 15s8 1.9 8 5.5"/></svg>',
    cart:
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>',
  };

  /* =========================================================
     1. 黒トップバー（SNS4アイコン＋送料無料等ロテーション・LINEなし）
     ========================================================= */
  (function utilityBar() {
    const bar = el("div", { class: "utilbar" });
    const inner = el("div", { class: "wrap utilbar-inner" });

    // 左: SNS 4アイコン（Instagram → YouTube → TikTok → Pinterest）
    const snsMap = {};
    (C.SNS || []).forEach(function (s) {
      snsMap[s.label] = s.url;
    });
    const sns = el("div", { class: "utilbar-sns" });
    ["Instagram", "YouTube", "TikTok", "Pinterest"].forEach(function (name) {
      if (!snsMap[name]) return;
      sns.appendChild(
        el("a", {
          class: "utilbar-ico",
          html: ICON[name],
          attrs: {
            href: snsMap[name],
            target: "_blank",
            rel: "noopener",
            "aria-label": name,
          },
        })
      );
    });

    // 中央: アナウンス（‹ 前 / 次 ›）
    const msgs = C.TOPBAR_MSGS && C.TOPBAR_MSGS.length ? C.TOPBAR_MSGS : [C.ANNOUNCE];
    const center = el("div", { class: "utilbar-msg" });
    const prev = el("button", {
      class: "utilbar-arrow",
      text: "‹",
      attrs: { type: "button", "aria-label": "前のお知らせ" },
    });
    const txt = el("span", { class: "utilbar-msg-text", text: msgs[0] });
    const next = el("button", {
      class: "utilbar-arrow",
      text: "›",
      attrs: { type: "button", "aria-label": "次のお知らせ" },
    });
    if (msgs.length > 1) center.appendChild(prev);
    center.appendChild(txt);
    if (msgs.length > 1) center.appendChild(next);

    const spacer = el("div", { class: "utilbar-spacer" });
    inner.appendChild(sns);
    inner.appendChild(center);
    inner.appendChild(spacer);
    bar.appendChild(inner);
    frag.appendChild(bar);

    let idx = 0,
      timer = null;
    function show(n) {
      idx = (n + msgs.length) % msgs.length;
      txt.textContent = msgs[idx];
    }
    function restart() {
      if (timer) clearInterval(timer);
      if (msgs.length > 1) timer = setInterval(function () {
        show(idx + 1);
      }, 4500);
    }
    prev.addEventListener("click", function () {
      show(idx - 1);
      restart();
    });
    next.addEventListener("click", function () {
      show(idx + 1);
      restart();
    });
    restart();
  })();

  /* =========================================================
     2. ヘッダー（実ロゴ＋機種メガナビ＋検索/アカウント/カート＋モバイルハンバーガー）
     ========================================================= */
  (function header() {
    const bar = el("header", { class: "header" });
    const inner = el("div", { class: "wrap header-inner" });

    // ハンバーガー（モバイルのみ表示）
    const burger = el("button", {
      class: "header-burger",
      html: "<span></span><span></span><span></span>",
      attrs: {
        type: "button",
        "aria-label": "メニュー",
        "aria-expanded": "false",
        "aria-controls": "headerNav",
      },
    });

    // ロゴ（本店の実バッジ画像）
    const logo = el("a", {
      class: "logo",
      attrs: { href: "https://casebypca.com/", "aria-label": "PCA トップ" },
    });
    if (C.LOGO) {
      logo.appendChild(
        el("img", { class: "logo-img", attrs: imgAttrs(C.LOGO, 48, { alt: "PCA" }) })
      );
    } else {
      logo.textContent = "PCA";
    }

    // 機種メガナビ
    const nav = el("nav", { class: "header-nav", attrs: { id: "headerNav" } });
    (C.NAV_MENU || []).forEach(function (m) {
      const hasSub = m.sub && m.sub.length;
      const item = el("div", { class: "nav-item" + (hasSub ? " has-sub" : "") });
      const link = el("a", {
        class: "nav-link",
        attrs: { href: m.url },
      });
      link.appendChild(el("span", { class: "nav-label", text: m.label }));
      if (hasSub) {
        link.setAttribute("aria-expanded", "false");
        link.appendChild(el("span", { class: "nav-caret", text: "⌄" }));
      }
      item.appendChild(link);
      if (hasSub) {
        const sub = el("div", { class: "nav-sub" });
        m.sub.forEach(function (s) {
          sub.appendChild(
            el("a", { class: "nav-sub-link", text: s.label, attrs: { href: s.url } })
          );
        });
        item.appendChild(sub);
        // モバイル: 親タップでサブ開閉（PCではhoverで開く）
        // 親自身の遷移先(m.url)が無い項目（例: iPhone 18）は、PCでクリックしても
        // 遷移させない（サブメニューを開くためだけの見出しとして扱う）
        link.addEventListener("click", function (e) {
          if (window.matchMedia("(max-width: 1023px)").matches) {
            e.preventDefault();
            const open = item.classList.toggle("is-open");
            link.setAttribute("aria-expanded", open ? "true" : "false");
          } else if (!m.url) {
            e.preventDefault();
          }
        });
        // PC: ドロップダウンが画面右端を超えそうなら右揃えへ切替（折り返し対応）
        item.addEventListener("mouseenter", function () {
          if (!window.matchMedia("(min-width: 1024px)").matches) return;
          const r = item.getBoundingClientRect();
          item.classList.toggle("nav-flip", r.left + 210 > window.innerWidth - 8);
        });
      }
      nav.appendChild(item);
    });

    // 右: 検索 / アカウント / カート
    const icons = el("div", { class: "header-icons" });
    [
      ["search", "検索", "https://casebypca.com/search"],
      ["account", "アカウント", "https://casebypca.com/account"],
      ["cart", "カート", "https://casebypca.com/cart"],
    ].forEach(function (ic) {
      icons.appendChild(
        el("a", {
          class: "header-icon",
          html: ICON[ic[0]],
          attrs: { href: ic[2], "aria-label": ic[1] },
        })
      );
    });

    inner.appendChild(burger);
    inner.appendChild(logo);
    inner.appendChild(nav);
    inner.appendChild(icons);
    bar.appendChild(inner);
    frag.appendChild(bar);

    function closeMenu() {
      bar.classList.remove("nav-open");
      burger.setAttribute("aria-expanded", "false");
    }
    burger.addEventListener("click", function (e) {
      e.stopPropagation();
      const open = bar.classList.toggle("nav-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) {
        const first = nav.querySelector(".nav-link");
        if (first) first.focus();
      }
    });
    // Escapeで閉じる / メニュー外クリックで閉じる（モバイル）
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && bar.classList.contains("nav-open")) {
        closeMenu();
        burger.focus();
      }
    });
    document.addEventListener("click", function (e) {
      if (bar.classList.contains("nav-open") && !bar.contains(e.target)) closeMenu();
    });
  })();


  /* =========================================================
     2.5. お盆休暇のお知らせ（テキスト・スライドバナー上部・期間限定・hide_after 到来で描画スキップ）
     ========================================================= */
  (function obonNotice() {
    const info = C.OBON_NOTICE;
    if (!info) return;
    const now = new Date();
    const hideAt = info.hide_after ? new Date(info.hide_after) : null;
    if (hideAt && now >= hideAt) return; // 期限切れは何も描画しない
    const sec = el("section", {
      class: "obon-notice",
      attrs: {
        id: "obon-notice",
        role: "region",
        "aria-label": "お盆休暇のお知らせ",
      },
    });
    const wrap = el("div", { class: "wrap obon-notice-wrap" });
    const box = el("div", { class: "obon-notice-inner" });
    box.appendChild(el("h2", { class: "obon-notice-title", text: info.title }));
    box.appendChild(el("div", { class: "obon-notice-body", html: info.body_html }));
    wrap.appendChild(box);
    sec.appendChild(wrap);
    frag.appendChild(sec);
  })();

  /* =========================================================
     3. ヒーロー（Magnet / ネオン / カスタムNAME の3枚）
     ========================================================= */
  let heroTimer = null;
  (function hero() {
    const slides = C.HERO_SLIDES || [];
    const sec = el("section", { class: "hero", attrs: { id: "hero" } });
    const viewport = el("div", { class: "hero-viewport" });
    const track = el("div", { class: "hero-track" });

    slides.forEach(function (s, i) {
      const a = el("a", {
        class: "hero-slide",
        attrs: { href: s.link, "aria-label": s.label },
      });
      const img = el("img", {
        class: "hero-img",
        attrs: {
          src: cdnUrl(s.image, 1200),
          srcset:
            cdnUrl(s.image, 800) + " 800w, " +
            cdnUrl(s.image, 1200) + " 1200w, " +
            cdnUrl(s.image, 1600) + " 1600w",
          sizes: "(max-width: 640px) 100vw, 1200px",
          alt: s.alt || s.label,
          decoding: "async",
          loading: i === 0 ? "eager" : "lazy",
          fetchpriority: i === 0 ? "high" : "auto",
        },
      });
      const cap = el("span", { class: "hero-cap", text: s.label });
      a.appendChild(img);
      a.appendChild(cap);
      track.appendChild(a);
    });
    viewport.appendChild(track);

    const dots = el("div", { class: "hero-dots" });
    slides.forEach(function (s, i) {
      const d = el("button", {
        class: "hero-dot" + (i === 0 ? " is-active" : ""),
        attrs: { type: "button", "aria-label": "スライド" + (i + 1) },
      });
      d.addEventListener("click", function () {
        go(i);
        restart();
      });
      dots.appendChild(d);
    });

    sec.appendChild(viewport);
    sec.appendChild(dots);
    frag.appendChild(sec);

    let idx = 0;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      track.style.transform = "translateX(" + -idx * 100 + "%)";
      Array.prototype.forEach.call(dots.children, function (dot, j) {
        dot.classList.toggle("is-active", j === idx);
      });
    }
    function next() {
      go(idx + 1);
    }
    function restart() {
      if (heroTimer) clearInterval(heroTimer);
      if (slides.length > 1) heroTimer = setInterval(next, 5000);
    }
    if (slides.length > 1) restart();
  })();

  /* =========================================================
     4. 複数購入割引バナー
     ========================================================= */
  (function discount() {
    const d = C.DISCOUNT || {};
    const a = el("a", {
      class: "discount",
      attrs: {
        href: d.link,
        "aria-label": (d.badge ? d.badge + "：" : "") + String(d.text || "").replace(/\n/g, " "),
      },
    });
    // 2026-09-23・クライアント指示: 「買うほどおトク！」はオレンジ系バッジとして左上寄りに表示し、
    // 本文はその下（.discount-body で縦積み）。矢印は引き続きカード右端・上下中央（.discount の
    // align-items:center による）。"SALE" バッジは復活させない。
    const body = el("div", { class: "discount-body" });
    if (d.badge) body.appendChild(el("span", { class: "discount-badge", text: d.badge }));
    body.appendChild(multilineText("span", "discount-text", d.text));
    a.appendChild(body);
    a.appendChild(el("span", { class: "discount-arrow", text: "→" }));
    const w = el("div", { class: "wrap" });
    w.appendChild(a);
    frag.appendChild(el("div", { class: "discount-band", children: [w] }));
  })();

  /* =========================================================
     4.5. お盆期間のお知らせ（画像バナー・SALE直下・LIVE準拠 2026-07-23）
     ========================================================= */
  (function notice() {
    const n = C.NOTICE;
    if (!n || !n.image) return;
    const img = el("img", {
      attrs: { src: n.image, alt: "お盆期間のお知らせ", style: "width:100%;display:block;border-radius:12px;" }
    });
    const content = n.link
      ? el("a", { attrs: { href: n.link }, children: [img] })
      : img;
    frag.appendChild(el("div", { class: "notice-band", children: [content] }));
  })();

  /* =========================================================
     4.6. お急ぎ発送バナー（2〜3日以内に発送・SALE帯直下・2026-08-13）
     ========================================================= */
  (function quickShip() {
    const q = C.QUICKSHIP;
    if (!q || !q.link) return;
    const a = el("a", {
      class: "quickship",
      attrs: {
        href: q.link,
        "aria-label": (q.badge ? q.badge + "：" : "") + String(q.text || "").replace(/\n/g, " "),
      },
    });
    // 2026-09-23・クライアント指示: 「すぐ発送」バッジ（既存の青いバッジデザインを流用）を左上寄りに表示し、
    // 本文はその下（.quickship-body で縦積み）。矢印は引き続きカード右端・上下中央。
    const body = el("div", { class: "quickship-body" });
    if (q.badge) body.appendChild(el("span", { class: "quickship-badge", text: q.badge }));
    body.appendChild(multilineText("span", "quickship-text", q.text));
    a.appendChild(body);
    a.appendChild(el("span", { class: "quickship-arrow", text: "→" }));
    const w = el("div", { class: "wrap" });
    w.appendChild(a);
    frag.appendChild(el("div", { class: "quickship-band", children: [w] }));
  })();

  /* =========================================================
     5. 機種選択（site-preview型の横スクロールウィジェット＝Canva指示）
     ========================================================= */
  (function models() {
    const sec = section("models", { class: "sec-models" });
    const panel = el("div", { class: "model-panel" });
    panel.appendChild(
      el("h2", { class: "model-title", text: "あなたのiPhoneから探す" })
    );
    const scroller = el("div", { class: "model-scroller" });
    (C.MODEL_CHIPS || C.MODELS || []).forEach(function (m) {
      scroller.appendChild(
        el("a", {
          class: "model-chip",
          text: m.label,
          attrs: { href: m.url },
        })
      );
    });
    panel.appendChild(scroller);
    sec._inner.appendChild(panel);
    frag.appendChild(sec);
  })();

  /* =========================================================
     5.5. カテゴリーナビ（iPhone以外・2026-07-21 クライアント指示②）
     ========================================================= */
  (function categoryNav() {
    const items = C.CATEGORY_NAV || [];
    if (!items.length) return;
    const assets =
      (typeof window !== "undefined" && window.PCA_F_ASSETS && window.PCA_F_ASSETS.catnav) ||
      {};
    const sec = section("catnav", { class: "sec-catnav" });
    const scroller = el("div", { class: "catnav-scroller" });
    items.forEach(function (c) {
      const a = el("a", {
        class: "catnav-item",
        attrs: { href: c.url, "aria-label": c.label },
      });
      const src = assets[c.key] || "./cat_" + c.key + ".png";
      a.appendChild(
        el("img", {
          class: "catnav-img",
          attrs: imgAttrs(src, 96, { alt: c.label }),
        })
      );
      a.appendChild(el("span", { class: "catnav-label", text: c.label }));
      scroller.appendChild(a);
    });
    sec._inner.appendChild(scroller);
    frag.appendChild(sec);
  })();

  /* =========================================================
     6. “気分”で選ぶ♪（新設＝Canva指示の6カテゴリ）
     ========================================================= */
  (function moods() {
    const sec = section("moods", { class: "sec-moods" });
    sec._inner.appendChild(heading("“気分”で選ぶ♪"));
    sec._inner.appendChild(
      el("p", { class: "sec-sub", text: "なりたい雰囲気からケースを探す" })
    );
    const grid = el("div", { class: "mood-grid" });
    (C.MOODS || []).forEach(function (m) {
      const a = el("a", {
        class: "mood-pill",
        attrs: { href: m.url, "aria-label": m.label },
      });
      a.appendChild(el("span", { class: "mood-emoji", text: m.emoji }));
      a.appendChild(el("span", { class: "mood-label", text: m.label }));
      grid.appendChild(a);
    });
    sec._inner.appendChild(grid);
    frag.appendChild(sec);
  })();

  /* =========================================================
     7. テイストで探す（8カテゴリ・A案のまま）
     ========================================================= */
  (function tastes() {
    const sec = section("tastes", { class: "sec-tastes" });
    sec._inner.appendChild(heading("テイストで探す"));
    const grid = el("div", { class: "taste-grid" });
    (C.TASTES || []).forEach(function (t) {
      const a = el("a", {
        class: "taste-card",
        attrs: { href: t.url, "aria-label": t.label },
      });
      const thumb = el("div", { class: "taste-thumb" });
      thumb.appendChild(
        el("img", {
          attrs: imgAttrs(t.image, 280, { alt: t.label }),
        })
      );
      a.appendChild(thumb);
      a.appendChild(el("span", { class: "taste-label", text: t.label }));
      grid.appendChild(a);
    });
    sec._inner.appendChild(grid);
    frag.appendChild(sec);
  })();

  /* =========================================================
     8. 推しカラーで選ぶ（新設＝Canva「できたら」項目）
     ========================================================= */
  (function colors() {
    const sec = section("colors", { class: "sec-colors" });
    sec._inner.appendChild(heading("推しカラーで選ぶ"));
    // 補足文は2026-09-23にクライアント指示で削除（要素ごと非表示。見出しのmargin-bottom(18px)で
    // 他セクション（テイストで探す等）と同様の自然な間隔になる・CSS変更不要）。
    const row = el("div", { class: "color-row" });
    (C.COLORS || []).forEach(function (c) {
      const a = el("a", {
        class: "color-chip",
        attrs: {
          href: "https://pca-design-compe.pages.dev/f/color.html?c=" + encodeURIComponent(c.label),
          "aria-label": c.label + "のケースを探す",
        },
      });
      const dot = el("span", { class: "color-dot" });
      dot.style.background = c.hex;
      a.appendChild(dot);
      a.appendChild(el("span", { class: "color-label", text: c.label }));
      row.appendChild(a);
    });
    sec._inner.appendChild(row);
    frag.appendChild(sec);
  })();

  /* =========================================================
     9. 人気RANKING（横スクロール化＋★実件数＝Canva指示）
     ========================================================= */
  (function ranking() {
    const sec = section("ranking", { class: "sec-ranking" });
    const rankHead = heading("人気RANKING", { class: "band band-pink" });
    const rankHeadLink = el("a", {
      class: "rank-heading-link",
      attrs: {
        href: "/collections/ranking",
        "aria-label": "人気RANKING TOP10を見る",
      },
    });
    rankHeadLink.appendChild(rankHead);
    sec._inner.appendChild(rankHeadLink);
    // 補足文は2026-09-23にクライアント指示で削除（要素ごと非表示。見出しのmargin-bottom(18px)で
    // 他セクション（テイストで探す等）と同様の自然な間隔になる・CSS変更不要）。
    const scroller = el("div", { class: "rank-scroller" });
    // 下敷き優先（build_ranking_data.py が /collections/ranking から生成）
    // 表示時は live-data.js の refreshRanking() が同エンドポイントから最新化
    const rankingList = (C.RANKING_BAKED && C.RANKING_BAKED.length)
      ? C.RANKING_BAKED
      : (C.RANKING || []);
    rankingList.forEach(function (p, i) {
      const a = el("a", {
        class: "rank-card",
        attrs: { href: p.url, "aria-label": cleanTitle(p.title) },
      });
      const media = el("div", { class: "rank-media" });
      media.appendChild(el("span", { class: "rank-badge", text: String(i + 1) }));
      media.appendChild(
        el("img", {
          class: "rank-img",
          attrs: imgAttrs(p.image, 220, { alt: cleanTitle(p.title) }),
        })
      );
      a.appendChild(media);

      const body = el("div", { class: "rank-body" });
      body.appendChild(el("p", { class: "rank-title", text: cleanTitle(p.title) }));
      // review_count>0 のみ ★5＋件数（実データのみ・創作禁止）
      if (Number(p.review_count) > 0) {
        body.appendChild(
          el("div", {
            class: "rate",
            html:
              starsHTML(5) +
              '<span class="rate-count">(' +
              p.review_count +
              ")</span>",
          })
        );
      }
      body.appendChild(el("p", { class: "price", text: yen(p.price) }));
      a.appendChild(body);
      scroller.appendChild(a);
    });
    sec._inner.appendChild(scroller);
    frag.appendChild(sec);
  })();

  /* =========================================================
     10. みんなのレビュー（カード全体を商品ページへのリンク化＝Canva指示）
     ========================================================= */
  (function reviews() {
    const sec = section("reviews", { class: "sec-reviews" });
    sec._inner.appendChild(heading("みんなのレビュー"));
    // 補足文は2026-09-23にクライアント指示で削除（要素ごと非表示。見出しのmargin-bottomで
    // 他セクションと同様の自然な間隔になる・CSS変更不要）。
    const grid = el("div", { class: "review-grid" });
    // 2026-09-24・クライアント指示: PCで3列×2段=6件になるよう表示件数を5→6に変更
    // （Worker障害時の静的フォールバック用。Worker成功時はWorkerが返す件数をそのまま使う）。
    (C.REVIEWS || []).slice(0, 6).forEach(function (r) {
      const card = el("a", {
        class: "review-card",
        attrs: { href: r.url, "aria-label": r.product + " の商品ページへ" },
      });
      // 2026-09-23・クライアント指示: 左側に★＋本文、右側に正方形の商品画像という
      // 横並びレイアウトへ変更。商品補足（product名）・「この商品を見る→」は削除。
      const body = el("div", { class: "review-body" });
      body.appendChild(el("div", { class: "rate", html: starsHTML(r.stars) }));
      body.appendChild(
        el("blockquote", { class: "review-quote", text: "“" + r.quote + "”" })
      );
      card.appendChild(body);
      // 画像は基本的にREVIEWSデータ自体には無いため、同じ商品url を持つ既存データ
      // （ランキング/新着＝実在確認済み画像）から取得する。ただしREVIEWS側にimageが
      // 直接指定されている場合（2026-09-24追加の6件目等）はそれを優先する。
      // どちらでも見つからなければ画像なし。
      const hit = findReviewImage(r.url);
      const reviewImage = r.image || (hit && hit.image);
      if (reviewImage) {
        card.appendChild(
          el("img", {
            class: "review-thumb",
            attrs: imgAttrs(reviewImage, 110, { alt: cleanTitle((hit && hit.title) || r.product) }),
          })
        );
      }
      grid.appendChild(card);
    });
    sec._inner.appendChild(grid);
    frag.appendChild(sec);
  })();

  /* =========================================================
     11. NEW ARRIVAL（商品名1行表示＝Canva指示）
     ========================================================= */
  (function newArrival() {
    const sec = section("new", { class: "sec-new" });
    sec._inner.appendChild(heading("NEW ARRIVAL", { class: "band band-blue" }));
    const grid = el("div", { class: "product-grid" });
    // 日次自動更新の下敷き（build_new_arrivals_data.py 生成）を優先し、
    // 無ければ shared PRODUCTS の先頭を使う。表示時に live-data.js が
    // さらに本店products.jsonから最新へ差し替える（三段構え）。
    const baked = (C.NEW_ARRIVALS_BAKED && C.NEW_ARRIVALS_BAKED.length)
      ? C.NEW_ARRIVALS_BAKED
      : (PRODUCTS || []).slice(0, 8);
    baked.forEach(function (p) {
      const url = p.url || ("https://casebypca.com/products/" + p.handle);
      const a = el("a", {
        class: "product-card",
        attrs: { href: url, "aria-label": cleanTitle(p.title) },
      });
      const media = el("div", { class: "product-media" });
      media.appendChild(el("span", { class: "product-tag", text: "NEW" }));
      media.appendChild(
        el("img", {
          class: "product-img",
          attrs: imgAttrs(p.image, 280, { alt: cleanTitle(p.title) }),
        })
      );
      a.appendChild(media);
      const body = el("div", { class: "product-body" });
      body.appendChild(el("p", { class: "product-title", text: cleanTitle(p.title) }));
      body.appendChild(el("p", { class: "price", text: yen(p.price) }));
      a.appendChild(body);
      grid.appendChild(a);
    });
    sec._inner.appendChild(grid);

    const more = el("div", { class: "sec-more" });
    more.appendChild(
      el("a", {
        class: "pill pill-primary",
        text: "すべての新作を見る",
        attrs: {
          // /collections/all は自動生成カタログのためデフォルト並びが変更不可。
          // URLパラメータで作成日降順を指定して着地時に新着順にする（ユーザーは
          // 並び替えUIで別の並びへ変更可能）。
          href: "https://casebypca.com/collections/all?sort_by=created-descending"
        },
      })
    );
    sec._inner.appendChild(more);
    frag.appendChild(sec);
  })();

  /* =========================================================
     12. 安心バッジ（ここから下＝黄×黒ポップゾーン・LINE項目なし）
     ========================================================= */
  (function badges() {
    const sec = section("badges", { class: "sec-badges" });
    sec._inner.appendChild(heading("安心してお買い物を"));
    const grid = el("div", { class: "badge-grid" });
    (C.BADGES || []).forEach(function (b) {
      const card = el("div", { class: "badge-card" });
      if (b.icon) {
        card.appendChild(el("div", { class: "badge-icon", text: b.icon }));
      }
      card.appendChild(el("h3", { class: "badge-title", text: b.title }));
      card.appendChild(el("p", { class: "badge-text", text: b.text }));
      if (b.link) {
        card.appendChild(
          el("a", {
            class: "badge-link",
            text: (b.link_label || "詳しく見る") + " →",
            attrs: { href: b.link },
          })
        );
      }
      grid.appendChild(card);
    });
    sec._inner.appendChild(grid);
    frag.appendChild(sec);
  })();

  /* =========================================================
     13. よみもの（新設＝Canva指示「洋介くんの記事」）
     公式ブログの公開記事。Shopify実装時はブログ連携で自動更新にする。
     ========================================================= */
  (function articles() {
    const sec = section("articles", { class: "sec-articles" });
    // 見出し・サブコピーのみ2026-09-24にクライアント指示で変更（記事カード等の構成は現状維持）。
    sec._inner.appendChild(heading("迷ったらこちら"));
    sec._inner.appendChild(
      el("p", { class: "sec-sub", text: "ぴったりのケースを見つけよう。" })
    );
    const grid = el("div", { class: "article-grid" });
    // 最新記事のみ掲載（ARTICLESは新しい順・先頭1件を表示）
    (C.ARTICLES || []).slice(0, 1).forEach(function (ar) {
      const a = el("a", {
        class: "article-card",
        attrs: { href: ar.url, "aria-label": ar.title },
      });
      const thumb = el("div", { class: "article-thumb" });
      thumb.appendChild(
        el("img", {
          attrs: imgAttrs(ar.image, 640, { alt: ar.title }),
        })
      );
      a.appendChild(thumb);
      const body = el("div", { class: "article-body" });
      body.appendChild(el("span", { class: "article-date", text: ar.date }));
      body.appendChild(el("p", { class: "article-title", text: ar.title }));
      // 「読む →」は2026-09-24にクライアント指示で削除（要素ごと非生成）。カード全体が
      // リンクなので導線は維持される。.article-goのmargin-top:autoは単一カード表示では
      // 実際の余白を消費していなかったため、.article-bodyのpaddingは変更していない。
      a.appendChild(body);
      grid.appendChild(a);
    });
    sec._inner.appendChild(grid);

    const more = el("div", { class: "sec-more" });
    more.appendChild(
      el("a", {
        class: "pill pill-primary",
        text: "記事をぜんぶ見る",
        attrs: { href: C.BLOG_URL },
      })
    );
    sec._inner.appendChild(more);
    frag.appendChild(sec);
  })();

  /* =========================================================
     14. #PCAのある暮らし（SNS＋コラージュ・黄×黒ポップ）
     ========================================================= */
  (function sns() {
    const sec = section("sns", { class: "sec-sns" });
    sec._inner.appendChild(heading("#PCAのある暮らし"));
    // サブコピーは2026-09-24にクライアント指示で削除（見出し→SNSボタンのシンプル構成。
    // 代替コピーは入れない。見出しのmargin-bottomで他セクション同様の自然な間隔になる）。
    const grid = el("div", { class: "sns-grid" });
    (C.SNS || []).forEach(function (s) {
      grid.appendChild(
        el("a", {
          class: "pill sns-pill",
          text: s.label,
          attrs: { href: s.url, target: "_blank", rel: "noopener" },
        })
      );
    });
    sec._inner.appendChild(grid);

    // 商品画像6枚のコラージュ（実商品データのみ使用・2026-09-24より1日単位の自動ローテーション）
    const collage = el("div", { class: "sns-collage" });
    const lifeShots = PCA_LIFE_IMAGE_POOL.length
      ? dailyPick(PCA_LIFE_IMAGE_POOL, 6)
      : (PRODUCTS || []).slice(8, 14); // プールが万一空の場合の保険（従来の固定6枚）
    lifeShots.forEach(function (p) {
      const a = el("a", {
        class: "sns-shot",
        attrs: {
          href: "https://casebypca.com/products/" + p.handle,
          "aria-label": cleanTitle(p.title),
        },
      });
      a.appendChild(
        el("img", {
          attrs: imgAttrs(p.image, 190, { alt: cleanTitle(p.title) }),
        })
      );
      collage.appendChild(a);
    });
    sec._inner.appendChild(collage);
    frag.appendChild(sec);
  })();

  /* =========================================================
     15. フッター（LINE CTAは削除＝Canva指示）
     ========================================================= */
  (function footer() {
    const f = el("footer", { class: "footer" });
    const w = el("div", { class: "wrap" });
    w.appendChild(el("div", { class: "footer-logo", text: "PCA" }));
    const nav = el("nav", { class: "footer-links" });
    (C.FOOTER_LINKS || []).forEach(function (l) {
      nav.appendChild(
        el("a", { class: "footer-link", text: l.label, attrs: { href: l.url } })
      );
    });
    w.appendChild(nav);
    w.appendChild(
      el("p", {
        class: "footer-copy",
        text: "© " + new Date().getFullYear() + " PCA (case by PCA)",
      })
    );
    f.appendChild(w);
    frag.appendChild(f);
  })();

  /* =========================================================
     16. モバイル固定ボトムバー（LINEボタンなしの2導線）
     ========================================================= */
  (function bottomBar() {
    const bar = el("nav", { class: "bottom-bar" });
    bar.appendChild(
      el("a", { text: "📱 機種で探す", attrs: { href: "#models" } })
    );
    bar.appendChild(
      el("a", { text: "✦ テイストで探す", attrs: { href: "#tastes" } })
    );
    frag.appendChild(bar);
  })();

  /* ---------- mount ---------- */
  $app.appendChild(frag);
})();
